

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IsMobile } from 'app/app';
import { DisplayMode, MarketingItem } from 'app/modules/cms/model/marketing-campaign-models';
import { openDocument } from 'app/modules/corporate/service/corporate.service';
import { IRootState } from 'app/shared/reducers';
import { getDocumentPathFromProductCode, scrollToTop } from 'app/shared/util/method-util';
import { isArray, isNull } from 'lodash';
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, Row } from 'reactstrap';
import { notAsked, RD, SRD, success } from 'srd';
import packageJson from '../../../../../../../package.json';

import { getContent } from 'app/modules/cms/service/store/cms-selectors';
import { CmsPageContentType } from 'app/modules/cms/tools/types';
import { isEndStep } from 'app/modules/journey/service/store/step.selector';
import './footer.scss';
import moment from 'moment';

const Footer = ({ didomi, spbLogoUrl, productCode }) => {

  const REACT_APP_VERSION = packageJson.version.replace('-SNAPSHOT', '');
  const dispatch = useDispatch()

  const isMobile = useContext(IsMobile);
  const [footerSRD, setFooterSRD] = React.useState<RD<string, any[]>>(notAsked())
  const marketingStore = useSelector((state: IRootState) => state.cms.marketing);
  const documentPath = productCode && getDocumentPathFromProductCode(productCode);
  const cmsContent = useSelector((state: IRootState) => state.cms.content)[CmsPageContentType.APP_GLOBAL_TYPE]
  const _isEndStep = useSelector(isEndStep);

  let infoPopinContent: MarketingItem[] = [];

  useEffect(() => {
    if (marketingStore.marketingItems) {
      infoPopinContent = marketingStore.marketingItems[DisplayMode.INFO_POP_IN];
      if (isArray(infoPopinContent) && infoPopinContent.length > 0)
        setFooterSRD(success(infoPopinContent))
    } else {
      setFooterSRD(success([]))
    }
  }, [marketingStore]);

  const handleOpenDocument = (url, type) => {
    dispatch(openDocument(url, type));
  }

  const showMarketing = (content) => {
    return content.map((item, index) => {
      const classNames = "footerFlexBoxItem footerFlexBoxItem" + ++index;
      return (
        <div className={classNames} key={index}>
          <img alt='cover' src={item.iconURL} />
          <p>
            {item.title}
          </p>
        </div>
      )
    })
  }

  const gestionCookies = (didomiObject) => {
    if (didomiObject) didomiObject.preferences.show();
  }

  const FooterContent = ({ content }) => {
    return (
      <div className="footerWrapper">
        {!isMobile && content?.length > 0 && <Row className="aboveFooter">
          <Col md="12" className="footerContainer">
            <div className="footerFlexBoxContainer">
              {showMarketing(content)}
              <Button color="primary" className="scrollButton" onClick={() => scrollToTop()}>
                <FontAwesomeIcon icon="arrow-up" size="lg" />
              </Button>{' '}
            </div>

          </Col>
        </Row>
        }
        {isMobile && <Row className="mobileAboveFooter">
          <Col md="12">
            <div className="footerFlexBoxContainer">
              <div className="footerMobileFlexBoxItem">
                <div className="mobileWidgetItems">
                  <div className="widgetHeader"></div>
                </div>

              </div>
              <div className="footerMobileFlexBoxItem">
                <div className="mobileWidgetItems">
                  <div className="widgetHeader"></div>
                </div>
              </div>
              <div className="footerMobileFlexBoxItem">
                <div className="mobileWidgetItems">
                  <div className="widgetHeader"></div>
                </div>
              </div>
            </div>

          </Col>
        </Row>}


        <Row className="lastFooter">
          <Col md="12">
            <div className="lastFooterFlexBox">
              {!isNull(spbLogoUrl) && <div className="lastFooterFlexBoxItem lastFooterFlexBoxItem1">
                <img alt='cover' className="footerSPBIconResponsive" src={spbLogoUrl} />
              </div>}
              {
                <div className="lastFooterFlexBoxItem lastFooterFlexBoxItem2">
                  <a onClick={() => handleOpenDocument("https://assurances.spb.eu/documents/" + documentPath + "/LegalNotice.pdf", "Mentions légales")} className="footerDocuments">
                    {cmsContent && cmsContent?.legalNotice}</a>
                  {" | "}
                  <a onClick={() => handleOpenDocument("https://assurances.spb.eu/documents/" + documentPath + "/CharteConfidentialite.pdf", "Charte de confidentialité")} className="footerDocuments">
                    {cmsContent && cmsContent?.privacyPolicy}</a>
                  {" | "}
                  <a onClick={() => handleOpenDocument("https://assurances.spb.eu/documents/" + documentPath + "/CGU.pdf", "CGU")} className="footerDocuments">
                    {cmsContent && cmsContent?.termsOfService}</a>
                  {" | "}
                  {didomi && <a onClick={() => gestionCookies(didomi)} style={{ cursor: 'pointer' }} className="footerDocuments">
                    {cmsContent && cmsContent?.cookieManagement}</a>}
                  {didomi == null && <span style={{ color: 'gray' }}>
                    {cmsContent && cmsContent?.cookieManagement}</span>}
                </div>
              }
            </div>
          </Col>
        </Row>
        <div className="spb-footer-version">
          Copyright © {moment().format('YYYY')} version : {REACT_APP_VERSION}
        </div>
      </div>
    )
  }

  const view = SRD.match({
    notAsked: () => <div></div>,
    loading: () => <div></div>,
    failure: (e) => <div></div>,
    success: (content) => <FooterContent content={content} />
  }, footerSRD)

  return view;
};

export default Footer;
